// API related actions
export const FETCHING_INVOICES = '@@toyota/FETCHING_INVOICES';
export const FETCHED_INVOICES = '@@toyota/FETCHED_INVOICES';
export const FETCHED_INVOICES_FAILED = '@@toyota/FETCHED_INVOICES_FAILED';
// complementary actions
export const CLEAR_INVOICES_DATA = '@@toyota/CLEAR_INVOICES_DATA';
export const CHANGE_INVOICES_LIST_PAGE = '@@toyota/CHANGE_INVOICES_LIST_PAGE';
export const CHANGE_INVOICES_LIST_PAGE_SIZE = '@@toyota/CHANGE_INVOICES_LIST_PAGE_SIZE';

export const GENERATE_ORDER_NOTE_REQUEST = '@@toyota/GENERATE_ORDER_NOTE_REQUEST';
export const GENERATE_ORDER_NOTE_SUCCESS = '@@toyota/GENERATE_ORDER_NOTE_SUCCESS';
export const GENERATE_ORDER_NOTE_FAILED = '@@toyota/GENERATE_ORDER_NOTE_FAILED';
export const CLEAR_ODER_NOTE_URL = '@@toyota/CLEAR_ODER_NOTE_URL';
